/**
 * FAQ accordion — one item open at a time per block instance.
 * The first item is rendered open server-side (.-is-open, aria-expanded="true").
 * Animates open/close via max-height, keeps [hidden] + aria-expanded in sync.
 */
const faqAccordion = () => {
  const accordions = document.querySelectorAll("[data-faq-accordion]");

  accordions.forEach((accordion) => {
    const toggles = accordion.querySelectorAll(".faq-list__toggle");

    const close = (toggle) => {
      const answer = document.getElementById(toggle.getAttribute("aria-controls"));
      if (!answer) return;
      toggle.setAttribute("aria-expanded", "false");
      // Pin the current height so the transition has a starting point,
      // even when the item was rendered open (max-height: none)
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.classList.remove("-is-open");
      requestAnimationFrame(() => {
        answer.style.maxHeight = null;
      });
      answer.addEventListener(
        "transitionend",
        () => {
          if (toggle.getAttribute("aria-expanded") === "false") {
            answer.hidden = true;
          }
        },
        { once: true }
      );
    };

    const open = (toggle) => {
      const answer = document.getElementById(toggle.getAttribute("aria-controls"));
      if (!answer) return;
      toggle.setAttribute("aria-expanded", "true");
      answer.hidden = false;
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.addEventListener(
        "transitionend",
        () => {
          if (toggle.getAttribute("aria-expanded") === "true") {
            // Release the clamp so the answer can reflow freely (resize, images)
            answer.style.maxHeight = "none";
          }
        },
        { once: true }
      );
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";

        toggles.forEach((other) => {
          if (other !== toggle && other.getAttribute("aria-expanded") === "true") {
            close(other);
          }
        });

        if (isOpen) {
          close(toggle);
        } else {
          open(toggle);
        }
      });
    });
  });
};

document.addEventListener("DOMContentLoaded", faqAccordion);

export default faqAccordion;
